import { createApp } from 'vue';
import App from './App.vue';
import router from './router'; // Import the router
import './assets/global.css';  // Correct import path for tailwind.css
import '@fortawesome/fontawesome-free/css/all.css';
import Aos from 'aos';
import "aos/dist/aos.css";
import { createPinia } from 'pinia';
// src/main.js
// Create the Vue app
const app = createApp(App);

// ✅ Tell Vue to treat mapbox-address-autofill as a custom element
app.config.compilerOptions.isCustomElement = (tag) =>
  tag === "mapbox-address-autofill";

// Plugins
const pinia = createPinia();
app.use(pinia);
app.use(router);

// Mount
app.mount('#app');

// Init animations
Aos.init();
